module.exports = __webpack_public_path__ + "static/media/homescreen.e37aaa8a.png";